import TeamGenerator from "@components/generator";

function App() {
  return (
    <div className="App">
      <TeamGenerator />
    </div>
  );
}

export default App;
